import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

export const authConfig: AuthConfig = {
  tokenEndpoint: environment.comparanooapiurl + '/connect/token',
  userinfoEndpoint: environment.comparanooapiurl + '/connect/userinfo',
  clientId: 'ComparanooApi',
  scope: 'profile email roles offline_access',
  dummyClientSecret: '1264614b-1b66-45de-a014-b8d840cfa4be',
  // silentRefreshRedirectUri:
  //   window.location.origin + '/assets/silent-refresh.html',
  // timeoutFactor: 0.75,
  // sessionChecksEnabled: true,
  // sessionCheckIFrameUrl: environment.comparanooapiurl + '/connect/checksession',
  // useSilentRefresh: true,
  showDebugInformation: false,
  // fallbackAccessTokenExpirationTimeInSec: 60000,
  clockSkewInSec: 900, //15 minutes
};
